import React from 'react';
//import ReactDOM from 'react-dom';
import ReactDOM from 'react-dom/client';

import { Link, BrowserRouter } from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css';
import '../node_modules/toastr/build/toastr.min.css';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
//import {renuevaSessionUser, initTimer} from './actions/finSessionActions';
import {renuevaSessionUser, initTimer} from './actions/userActions';

import configureStore from './store/configureStore';
import {Provider} from 'react-redux';
import './index.css';
//import Amplify from "aws-amplify";
import { Amplify } from 'aws-amplify';
//import {  I18n } from 'aws-amplify/utils';
import awsExports from "./aws-exports";
Amplify.configure(awsExports);
//I18n.setLanguage('es');

export const store=configureStore();

store.dispatch(initTimer());
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <BrowserRouter  basename={"/"}>
    <Provider store={store}>
    <App />
    </Provider>
    </BrowserRouter>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console_.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
